import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Grid2 from '@shared/components/Grid2';
import { H2 } from '@shared/components/Heading';
import List from '@shared/components/List';
import ListItem from '@shared/components/ListItem';
import Paragraph from '@shared/components/Paragraph';
import Video from '@shared/components/Video';
import { FC, memo } from 'react';

import { SectionDark3 } from '../../components/ColoredSection';

const Selbstverteidigung: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <SectionDark3>
      <Grid2 spacing={{ md: '2rem', xs: '0' }}>
        <Grid2.Item>
          <H2>Selbstverteidigung</H2>

          <Paragraph>
            <Route href={RoutePath.Selbstverteidigung}>Selbstverteidigung</Route> beginnt bei der
            Kontrolle von unangemessenem Verhalten und endet bei der Verteidigung des eigenen
            Lebens.
          </Paragraph>

          {isMobile && <Video horizontal src={'1007005854'} />}

          <List bullets>
            <ListItem>
              Bei übergriffigem Verhalten möchtest Du Dich unauffällig verteidigen können.
              Beispielsweise gegen unangenehme Berührungen. Systema bietet Dir einzigartige
              Möglichkeiten, Dich auf sanfte Art zu behaupten.
            </ListItem>
            <ListItem>
              Wenn es um Dein Leben geht, dann brauchst Du extrem wirkungsvolle Techniken und eine
              stabile Psyche. Systema basiert auf militärischem Nahkampf und lehrt Dich, was Du
              brauchst.
            </ListItem>
            <ListItem>
              Nach jeder Auseinandersetzung geht es darum, wie Du mit dem Erlebten klar kommst und
              es verarbeitest. Bei uns lernst Du Entspannungs- und Regenerations-Techniken.
            </ListItem>
          </List>
        </Grid2.Item>
        <Grid2.Item>{isMobile || <Video horizontal src={'1007005854'} />}</Grid2.Item>
      </Grid2>
    </SectionDark3>
  );
};

export default memo(Selbstverteidigung);
